export default __webpack_public_path__ + "static/media/section-lieder.b4adcbc2.png";